import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65fbaf8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-overlay" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-body !tw-pb-4" }
const _hoisted_4 = { class: "modal-statement modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tw-pb-2" }, "Full Name ", -1))
const _hoisted_6 = { class: "modal-statement modal-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tw-pb-2" }, "Email Address ", -1))
const _hoisted_8 = { class: "modal-statement modal-content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tw-pb-2" }, "Select Role ", -1))
const _hoisted_10 = { class: "modal-statement modal-content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tw-pb-2" }, "Invited as ", -1))
const _hoisted_12 = { class: "modal-footer" }

import { ref, computed } from "vue";
import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import { getCurrentInstance } from "@vue/runtime-core";
import { displayToastMessage } from "@/core/utils/common";
import { USER_STORE } from "@/store/modules/user";
import { useStore } from "vuex";
import { PROJECT_STORE } from "@/store/modules/project";
import { MEMBER_STORE } from "@/store/modules/manage-member";

import PdfIcon from "@/core/components/icons/PdfIcon.vue";
import ImageIcon from "@/core/components/icons/ImageIcon.vue";
import Text from "@/core/components/ui/general/Text.vue";
import InputField from "@/core/components/common/InputField.vue";
import InputSelect from "@/core/components/common/InputSelect.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCandidateModal',
  props: {
  eligibility: {
    type: Object,
    default: null,
  },
},
  emits: ["on-close", "on-submit", "team-member-added"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emits = __emit;
const props = __props;

const eligibilityItems = ref([]) as any;

const internalInstance = getCurrentInstance();
const formRef = ref<any>(null);
const isUploadImg = ref<boolean>(false);

const validation = ref({
  candidate: [(v: string) => !!v || "Candidate name required"],
  email: [(v: string) => !!v || "Candidate email required"],
  attachments: [
    (v: any[]) => v.length > 0 || "At least one attachment is required",
  ],
  selectedRole: [(v: any) => !!v || "Role is required"],
  invitedAs: [(v: any) => !!v || "Invitation role is required"],
});

const candidateName = ref<string>("");
const candidateEmail = ref<string>("");
const selectedRole = ref<string>("");
const invitedAs = ref("");

const user = computed(() => store.getters[`${USER_STORE}/user`]);

const selectedDocuments = ref<any[]>([]);

const onFileChange = (event: any) => {
  const files = event.target.files;
  if (files && files.length > 0) {
    Array.from(files).forEach((file: any) => {
      if (!selectedDocuments.value.some((doc) => doc.name === file.name)) {
        selectedDocuments.value.push(file);
      }
    });
  }

  event.target.value = "";
};

const displayToast = (message: string, type: string) => {
  if (
    internalInstance &&
    internalInstance.appContext.config.globalProperties.$notify
  ) {
    internalInstance.appContext.config.globalProperties.$notify[type]({
      message,
    });
  }
};
const onSubmit = async () => {
  const isFormValid = await formRef.value.validate();

  if (!isFormValid.valid) return;

  try {
    isUploadImg.value = true;

    const payload = {
      members: [
        {
          email: candidateEmail.value,
          role: invitedAs.value,
          tags: JSON.stringify([selectedRole.value]),
        },
      ],
      userCourseId: props.userCourseId || null,
    };
    console.log("NEw are", payload);

    const response = await store.dispatch(`${MEMBER_STORE}/inviteMember`, {
      members: payload,
      userId: user.value?.id,
    });

    if (response) {
      if (response.data.length > 0) {
        emits("on-submit");
        displayToast("Invitation sent successfully", "success");
        emits("team-member-added");
      } else {
        displayToast("Mail already used", "success");
      }
    }
  } catch (err) {
    console.error("Error sending invitation:", err);
    displayToast("Failed to send invitation", "error");
  } finally {
    isUploadImg.value = false;
  }
};

const removeAttachment = (index: number) => {
  selectedDocuments.value.splice(index, 1);
};

const onClickBackButton = () => {
  return emits("on-close");
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "dispute-evidence-modal !tw-gap-0",
    onOnClose: onClickBackButton,
    maxWidth: "100%",
    width: "588px",
    borderRadius: "20px",
    isShowCloseButton: true,
    isShowHeader: true,
    isTitleStrong: true,
    headerTitle: "Add Candidate",
    headerDescription: "Please upload any evidence you may have and provide a statement to support your dispute.",
    headerDescriptionTextSize: "h6",
    headerDescriptionLineHeight: "20px",
    gap: "0"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_form, {
            ref_key: "formRef",
            ref: formRef,
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
            rules: validation.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(InputField, {
                    class: "!tw-w-full custom-selector",
                    modelValue: candidateName.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((candidateName).value = $event)),
                    rules: validation.value.candidate,
                    placeholder: "Candidate name here"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(InputField, {
                    class: "!tw-w-full custom-selector",
                    modelValue: candidateEmail.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((candidateEmail).value = $event)),
                    type: "email",
                    rules: validation.value.email,
                    placeholder: "Candidate email here"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(InputSelect, {
                    modelValue: selectedRole.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedRole).value = $event)),
                    class: "!tw-w-full",
                    rules: validation.value.selectedRole,
                    placeholder: "Select Role here",
                    items: ['Sole Director', 'Director', 'PAYE/ Employee']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(InputSelect, {
                    modelValue: invitedAs.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((invitedAs).value = $event)),
                    rules: validation.value.invitedAs,
                    class: "!tw-w-full",
                    placeholder: "Select Role here",
                    items: ['Admin', 'Editor', 'Viewer']
                  }, null, 8, ["modelValue", "rules"])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_v_btn, {
                  class: "button button-purple-border",
                  onClick: onClickBackButton,
                  disabled: isUploadImg.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancel ")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  class: "button button-purple",
                  onClick: onSubmit,
                  loading: isUploadImg.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Add Candidate ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ]),
            _: 1
          }, 8, ["rules"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})